module.exports = __webpack_public_path__ + "res/img_about.e3942336677e221592a0e34e907cc2ef.png";